// src/pages/Terms.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const C = {
  bg:        "#0d0a05",
  border:    "rgba(212,168,83,0.12)",
  gold:      "#d4a853",
  goldGhost: "var(--bone-text-muted)",
  ivory:     "#e8d5b0",
  ivoryGhost:"rgba(232,213,176,0.35)",
};

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 32 }}>
      <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 18, fontWeight: 700, color: C.gold, margin: "0 0 10px" }}>{title}</h2>
      <div style={{ height: 1, background: C.border, marginBottom: 14 }} />
      <div style={{ fontFamily: "'Courier Prime', monospace", fontSize: 12, color: C.ivoryGhost, lineHeight: 1.8, letterSpacing: "0.04em" }}>{children}</div>
    </div>
  );
}

export default function Terms() {
  const { t } = useTranslation();
  return (
    <div style={{ minHeight: "100vh", background: C.bg, padding: "40px clamp(20px,5vw,80px)" }}>
      <div style={{ maxWidth: 760, margin: "0 auto" }}>

        <Link to="/" style={{ fontFamily: "'Courier Prime', monospace", fontSize: 11, color: C.gold, textDecoration: "none", letterSpacing: "0.15em" }}>
          {t('legal.backHome')}
        </Link>

        <div style={{ margin: "24px 0 40px" }}>
          <p style={{ fontFamily: "'Courier Prime', monospace", fontSize: 9, letterSpacing: "0.38em", color: C.goldGhost, textTransform: "uppercase", marginBottom: 6 }}>
            ✦ {t('legal.eyebrow')} ✦
          </p>
          <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 36, fontWeight: 700, color: C.gold, margin: "0 0 8px" }}>
            {t('legal.terms.title')}
          </h1>
          <p style={{ fontFamily: "'Courier Prime', monospace", fontSize: 10, color: C.goldGhost, letterSpacing: "0.1em" }}>
            {t('legal.lastUpdated')}
          </p>
          <div style={{ height: 1, background: `linear-gradient(90deg,${C.gold},transparent)`, marginTop: 16, opacity: 0.2 }} />
        </div>

        <Section title={t('legal.terms.s1.title')}>{t('legal.terms.s1.body')}</Section>

        <Section title={t('legal.terms.s2.title')}>{t('legal.terms.s2.body')}</Section>

        <Section title={t('legal.terms.s3.title')}>
          {t('legal.terms.s3.intro')}<br /><br />
          — {t('legal.terms.s3.r1')}<br />
          — {t('legal.terms.s3.r2')}<br />
          — {t('legal.terms.s3.r3')}<br />
          — {t('legal.terms.s3.r4')}
        </Section>

        <Section title={t('legal.terms.s4.title')}>{t('legal.terms.s4.body')}</Section>
        <Section title={t('legal.terms.s5.title')}>{t('legal.terms.s5.body')}</Section>
        <Section title={t('legal.terms.s6.title')}>{t('legal.terms.s6.body')}</Section>
        <Section title={t('legal.terms.s7.title')}>{t('legal.terms.s7.body')}</Section>

        <div style={{ fontFamily: "'Courier Prime', monospace", fontSize: 9, color: C.goldGhost, letterSpacing: "0.14em", textAlign: "center", marginTop: 48, paddingTop: 24, borderTop: `1px solid ${C.border}`, display: "flex", gap: 20, justifyContent: "center" }}>
          <Link to="/privacy" style={{ color: C.goldGhost, textDecoration: "none" }}>{t('legal.privacyLink')}</Link>
          <span>·</span>
          <span>{t('legal.copyright')}</span>
        </div>

      </div>
      <style>{`* { box-sizing: border-box; }`}</style>
    </div>
  );
}
